import { useQuery } from "@tanstack/react-query";

import { preCourseAssessmentKeys } from "../../../../redux/services/preCourseAssessment";

import { getPreAssessmentQuestionApiCall } from "./utils.api";

export const useGetPreAssessmentQuestion = (payload) =>{
    const {languageid , courseId}= payload;

    return useQuery({
        queryKey: preCourseAssessmentKeys.getPreCourseAssessmentKeys({ courseId, languageid }),
        queryFn: () => getPreAssessmentQuestionApiCall({languageid , courseId}),
    });
}